module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag29_1519AT.dc3ffe86.jpg";